import { createI18n } from "vue-i18n";
import en from "@/locales/en.json";
import ru from "@/locales/ru.json";

export const SUPPORTED_LOCALES = ["ru", "en"] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "ru";

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    en,
    ru,
  },
});

export const setLocale = (locale: SupportedLocale) => {
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
};

setLocale(DEFAULT_LOCALE);
